import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import Text from 'shopper/components/Text';

import { isObj } from 'lib/object';
import { markup } from 'lib/utils';

const TextWithRichContent = forwardRef(
  ({ className, children, full, ...rest }, ref) => {
    const sharedClassName = twMerge(
      'text-neutral-low-100 [&_img]:max-w-full md:[&_img]:max-w-96 [&_img]:rounded-2 dark:text-neutral-high-200 hyphens-auto break-words [&>a]:line-break-anywhere [&>a]:hover:text-primary-300 [&>a]:hover:no-underline dark:[&>a]:hover:text-primary-100 [&>iframe,video]:max-h-48 [&>iframe,video]:max-w-full lg:[&>iframe,video]:max-h-64 [&>img]:max-h-60 [&>img]:max-w-48 md:[&>img]:max-h-112 md:[&>img]:max-w-80 lg:[&>img]:max-h-[600px] lg:[&>img]:max-w-[480px] hover:text-neutral-low-100 hover:dark:text-neutral-high-200',
      full && 'w-full',
      className
    );

    if (isObj(children) || Array.isArray(children)) {
      return (
        <Text ref={ref} className={sharedClassName} {...rest}>
          {children}
        </Text>
      );
    }

    return (
      <Text
        ref={ref}
        className={sharedClassName}
        dangerouslySetInnerHTML={markup(children)}
        {...rest}
      />
    );
  }
);

TextWithRichContent.displayName = 'TextWithRichContent';

TextWithRichContent.propTypes = {
  /**
   * Text or children to be rendered inside component
   */
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  full: PropTypes.bool,
};

export default TextWithRichContent;
